'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _reactStackGrid = require('react-stack-grid');

var _reactStackGrid2 = _interopRequireDefault(_reactStackGrid);

var _semanticWebflow = require('@bodhi-project/semantic-webflow');

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

var _keygen = require('../methods/keygen');

var _keygen2 = _interopRequireDefault(_keygen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries

// import moment from 'moment'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components

// import '@bodhi-project/antrd/lib/wonky/3.16.2/card/style/css'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// const { Fragment } = React

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Desktop
var blockStyle = (0, _glamor.css)({
  '& div.card': {
    border: '2px solid #285BA1',
    boxShadow: '2px 2px #e2620b',
    borderRadius: 5,
    background: '#FFFFFF',

    '& a': {
      display: 'block',
      border: 'unset !important',

      '&:hover': {
        border: 'unset !important'
      },

      '& .ant-card-body': {
        padding: '6px 9px'
      },

      '& header': {
        position: 'relative',

        '& h1': {
          marginBottom: 0
        },

        '& p': {
          marginTop: 10
        },

        '& .date': {
          background: '#FFFFFF',
          position: 'absolute',
          top: -38,
          left: -9,
          padding: '6px 9px'
        }
      }
    }
  }
});
var blockStyleClass = blockStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** Block */

var Block = function (_React$Component) {
  _inherits(Block, _React$Component);

  /** standard constructor */
  function Block(props) {
    _classCallCheck(this, Block);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      alreadyRendered: false
    };

    _this.grid = undefined;

    _this.reRender = _this.reRender.bind(_this);
    return _this;
  }

  /** reRender */


  Block.prototype.reRender = function reRender() {
    var _this2 = this;

    var alreadyRendered = this.state.alreadyRendered;

    if (alreadyRendered === false) {
      this.setState({ alreadyRendered: true });
      setTimeout(function () {
        _this2.grid.updateLayout();
        // this.setState({ alreadyRendered: false })
      }, 100);
    }
  };

  /** standard renderer */


  Block.prototype.render = function render() {
    var _this3 = this;

    var alreadyRendered = this.state.alreadyRendered;
    var _props = this.props,
        events = _props.events,
        Img = _props.Img,
        Link = _props.Link,
        _props$columnWidth = _props.columnWidth,
        columnWidth = _props$columnWidth === undefined ? '33%' : _props$columnWidth,
        _props$gutterWidth = _props.gutterWidth,
        gutterWidth = _props$gutterWidth === undefined ? 20 : _props$gutterWidth,
        _props$gutterHeight = _props.gutterHeight,
        gutterHeight = _props$gutterHeight === undefined ? 42 : _props$gutterHeight;


    return _react2.default.createElement(
      'div',
      { className: blockStyleClass },
      _react2.default.createElement(
        _reactStackGrid2.default,
        {
          columnWidth: columnWidth,
          duration: 360,
          gutterWidth: gutterWidth,
          gutterHeight: gutterHeight,
          monitorImagesLoaded: false,
          gridRef: function gridRef(grid) {
            return _this3.grid = grid;
          },
          onLayout: alreadyRendered === false && this.reRender
        },
        (0, _map2.default)(events, function (event) {
          var route = event.route,
              cover = event.cover,
              title = event.title,
              abstract = event.abstract,
              formattedDate = event.formattedDate;


          return _react2.default.createElement(
            'div',
            { className: 'card', key: (0, _keygen2.default)() },
            !(0, _isUndefined2.default)(route) && _react2.default.createElement(
              Link,
              { to: '/' + route },
              _react2.default.createElement(
                _card2.default,
                { cover: _react2.default.createElement(Img, { fluid: cover }), bordered: false },
                _react2.default.createElement(
                  _semanticWebflow.Article,
                  null,
                  _react2.default.createElement(
                    _semanticWebflow.Header,
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'date' },
                      formattedDate
                    ),
                    _react2.default.createElement(
                      'h1',
                      { className: 'mask-h5' },
                      _react2.default.createElement(
                        'span',
                        null,
                        title
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { marginBottom: 0 } },
                      _react2.default.createElement(
                        'span',
                        null,
                        abstract
                      )
                    )
                  )
                )
              )
            ),
            (0, _isUndefined2.default)(route) && _react2.default.createElement(
              _card2.default,
              { cover: _react2.default.createElement(Img, { fluid: cover }), bordered: false },
              _react2.default.createElement(
                'h3',
                { className: 'mask-h5' },
                _react2.default.createElement(
                  'span',
                  null,
                  title
                )
              )
            )
          );
        })
      )
    );
  };

  return Block;
}(_react2.default.Component);

Block.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

Block.defaultProps = {};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
exports.default = Block;
module.exports = exports['default'];